import { render, staticRenderFns } from "./ScheduledItem.vue?vue&type=template&id=4811bb2e&"
import script from "./ScheduledItem.vue?vue&type=script&lang=js&"
export * from "./ScheduledItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports